import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { MediaQuery as MQ } from '../../media-query';
import PromoMessage from '../promo-message';
import DatePicker from '../date-picker';
import { truncate } from '../../util';
import dayjs from 'dayjs';
import _ from 'underscore';

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = { width: window.innerWidth };
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);

        const date = this.props.date || dayjs().format('YYYY-MM-DD');
        this.date = date;
        this.props.requireNumber(date);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    /* eslint-disable complexity */
    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.logged_in != this.props.logged_in) {
            if (!nextProps.logged_in && this.props.base_url.match(/vip/)) { //user logs out on VIP page
                document.location.href = this.props.base_url.replace(/\/vip/, '');
                return false;
            } else if (
                nextProps.logged_in
                &&
                nextProps.user.subscriptions
                &&
                nextProps.user.subscriptions.vip
                &&
                !this.props.base_url.match(/vip/)
            ) { //user logs in on non-VIP page
                document.location.href = `/vip${this.props.base_url}`;
                return false;
            }

            this.props.getAutologin();
        }

        if (nextProps.autologin != this.props.autologin) {
            return true;
        }

        if (nextProps.number != this.props.number) {
            return true;
        }

        if (nextState.width >= 900 && this.state.width < 900) {
            return true;
        }

        if (nextState.width < 900 && this.state.width >= 900) {
            return true;
        }

        if (nextState.width >= 600 && this.state.width < 600) {
            return true;
        }

        if (nextState.width < 600 && this.state.width >= 600) {
            return true;
        }

        return false;
    }
    /* eslint-enable complexity */

    render({ base_url }) {
        return (
            <daily-number base_url={base_url} date={this.date}>
                {MQ.isMobile() ? this.renderMobile() : this.renderNonMobile()}
            </daily-number>
        );
    }

    renderMobile = () => {
        if (this.props.number) {
            const number = this.props.number;
            const placement = this.props.base_url.match(/vip/) ? 'in-product' : 'text';
            const tags = this.props.base_url.match(/vip/) ? 'vip,text,daily' : 'number';

            return (
                <daily-number-mobile date={this.date} base_url={this.props.base_url}>
                    <DatePicker
                        url={`${this.props.base_url || '/daily-number'}/:date`}
                        page='number'
                        autosubmit='true'
                    />
                    <h1>Number of the Day</h1>
                    <div className={`today-number nod-${number.personal_number}`} />
                    <div>
                        <h2>Your Daily Number: {number.number}</h2>
                        <h5>{number.title}</h5>
                        <p className='has-margin-10-top'>
                            <b>{dayjs(this.date).format('M.D.YY')}: </b>
                            <span dangerouslySetInnerHTML={{__html: truncate(number.content, 325)}} />
                            <a
                                href={this.renderNumeroLink()}
                                target='_blank'
                                rel='noopener'
                                onClick={this.trackClick}
                            >
                                Read More
                            </a>
                        </p>
                        <p><PromoMessage placement={placement} tags={tags} /></p>
                    </div>
                </daily-number-mobile>
            );
        }

        return (
            <daily-number-mobile date={this.date} base_url={this.props.base_url}>
                <DatePicker
                    url={`${this.props.base_url || '/daily-number'}/:date`}
                    page='number'
                    autosubmit='true'
                />
                <h1>Number of the Day</h1>
                <img
                    src='https://gfx.tarot.com/images/daily-pages/daily-icons/number.svg'
                    height='249'
                    width='225'
                    alt='Daily Number'
                />
                <h2>Create Your Profile To Find Out!</h2>
                <p>
                    Looking for your Number of the Day? Create your profile to receive a number that's personalized
                    to YOU every day!
                </p>
                <a href='#login' className='button'>CREATE MY PROFILE</a>
                <p className='signup_promo_text'>Already a Tarot.com member? <a href='#login'>Login Now</a></p>
            </daily-number-mobile>
        );
    }

    renderNonMobile = () => {
        if (this.props.number) {
            const placement = this.props.base_url.match(/vip/) ? 'in-product' : 'text';
            const tags = this.props.base_url.match(/vip/) ? 'vip,text,daily' : 'number';
            const number = this.props.number;

            return (
                <daily-number-non-mobile date={this.date}>
                    <div className='daily-number'>
                        <img
                            src={`https://gfx.tarot.com/images/numerology/daily/${number.personal_number}.jpg`}
                            alt='Daily Number'
                        />
                    </div>
                    <row>
                        <column className='is-1'>
                            <DatePicker
                                url={`${this.props.base_url || '/daily-number'}/:date`}
                                page='number'
                                autosubmit='true'
                            />
                        </column>
                        <column className='is-11'>
                            {this.renderDailyLinks()}
                        </column>
                    </row>
                    <h1>Number of<br />the Day</h1>
                    <div className='daily-links'>
                        <a href='/numerology'>Learn More About Numerology</a>
                    </div>
                    <br />
                    <p className='has-margin-10-top'>
                        <b>{dayjs(this.date).format('M.D.YY')}: </b>
                        <span dangerouslySetInnerHTML={{__html: truncate(number.content, 325)}} />
                        <a
                            href={this.renderNumeroLink()}
                            target='_blank'
                            rel='noopener'
                            onClick={this.trackClick}
                        >
                            Read More
                        </a>
                    </p>
                    <p><PromoMessage placement={placement} tags={tags} /></p>
                </daily-number-non-mobile>
            );
        }

        return (
            <daily-number-non-mobile date={this.date}>
                <div className='daily-number'>
                    <img
                        src='https://gfx.tarot.com/images/daily-pages/daily-icons/number.svg'
                        height='249'
                        width='225'
                        alt='Daily Number'
                        className='number-unknown'
                    />
                </div>
                <h1>Number of<br />the Day</h1>
                <div className='daily-links'>
                    <a href='/numerology'>Learn More About Numerology</a>
                </div>
                <br />
                <br />
                <h2>Your FREE Daily Number Awaits!</h2>
                <br />
                <p>
                    Looking for your Number of the Day? Create your profile to receive a number that's personalized
                    to YOU every day!
                </p>
                <p>
                    <a href='#login' className='button'>GET MY DAILY NUMBER</a>
                </p>
            </daily-number-non-mobile>
        );
    }

    renderNumeroLink = () => {
        const domain = _.contains(['stage', 'dev'], this.props.environment)
            ? 'http://numerology-stage.dig.lo'
            : 'https://numerology.com';
        const args = this.props.autologin
            ? `?today=${this.date}&m=${this.props.autologin.m}&mauto=${this.props.autologin.mauto}`
            : `?today=${this.date}`;

        return `${domain}/daily-number${args}`;
    }

    renderDailyLinks = () => {
        const yesterday = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
        const today = dayjs().format('YYYY-MM-DD');
        const tomorrow = dayjs().add(1, 'day').format('YYYY-MM-DD');

        return (
            <div className='daily-links'>
                <a
                    href={`${this.props.base_url || '/daily-number'}/${yesterday}`}
                    className={this.date == yesterday ? 'selected' : ''}
                >
                    Yesterday
                </a>
                <a
                    href={`${this.props.base_url || '/daily-number'}/${today}`}
                    className={this.date == today ? 'selected' : ''}
                >
                    Today
                </a>
                <a
                    href={`${this.props.base_url || '/daily-number'}/${tomorrow}`}
                    className={this.date == tomorrow ? 'selected' : ''}
                >
                    Tomorrow
                </a>
                <a href='/readings-reports/subscription/vip-membership'>VIP Horoscopes</a>
            </div>
        );
    }

    trackClick = () => {
        this.props.trackEvent([
            'Daily Number',
            `${this.props.logged_in ? 'LI' : 'LO'} Click`,
            'Read More',
        ]);
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth });
    }
}

const mapStateToProps = (state) => ({
    number: state.number,
    logged_in: state.user && state.user.logged_in,
    user: state.user,
    environment: state.environment,
    autologin: state.autologin,
});

const mapDispatchToProps = (dispatch) => ({
    requireNumber: (date) => dispatch({ type: 'number:required', payload: date }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    getAutologin: () => dispatch({ type: 'autologin:get' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
